import React from 'react'
import { HelpModal } from '../../help/help-modal.component'

export const MajorDeclaredHelp = ({modalRef}) =>
  <HelpModal innerRef={modalRef} title='Not declaring a major affects my financial aid?'>
    Yes! To keep receiving your TAP grant, you must declare a major if you've earned 30 credits (associate program) and
    60 credits (bachelor's program). If you fail to do so by the deadline, no TAP for this semester.
  </HelpModal>